<div class="questionVotingSection">
  <div class="timer-container">
      <div class="vote-time" *ngIf='meeting.meetingType == 0 && !startVotingTimer && item.votingModel && !item.votingClosed'>
          <div>
              <svg width="16" height="16" viewBox="0 0 16 16">
                  <path id="time-icon" d="M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0Zm3.8,12.138a.666.666,0,0,1-.943,0L7.529,8.8a.664.664,0,0,1-.2-.471V4A.667.667,0,1,1,8.667,4V8.057L11.8,11.2a.666.666,0,0,1,0,.943Zm0,0" fill="#ccc"/>
              </svg>
              <label>  {{ 'meetings.Durationvoting' | translate }}:</label>
              <div class="form-elements">
                  <div class="form-group">
                      <input matInput class="form-control" type="number"
                      [(ngModel)]="durationTime" [ngModelOptions]="{standalone: true}" appOnlynumber min="1" max="999">
                  </div>
              </div>
              <span>  {{ 'meetings.minutes' | translate }}</span>
          </div>
          <!-- <p class="has-error" *ngIf="noTimeInserted && durationTime == null">Please insert Duration Time</p> -->
      </div>

      <div class="timer" *ngIf='startVotingTimer && !noTimeInserted && !stopedClicked'>
          <countdown #cd
              [config]="{ leftTime: (durationTime*60), format: 'mm:ss' }"
              (event)="timesUp($event)"> </countdown>
      </div>
  </div>

  <ng-container *ngIf='!item.allowedVoting && !item.votingClosed'>
      <div class="agenda-voting-container" *ngIf="!item.votingModel && !allowVote">
          <div class="no-voting">
              <img src="./assets/images/icons/allow-for-voting-illustration.svg" alt="">
              <!-- Allow for Voting -->
              <div *ngIf="item.canChangeVote">
                  <button class="btn btn-primary" (click)='allowVoting(); termsEditable = true; disapledType= false;' *ngIf="meeting.meetingType == 0 && !isShow">{{ 'meetings.AllowVoting' | translate }}</button>
                  <div *ngIf="meeting.meetingType == 0 && isShow">
                    sorry! you cannot start voting during the duration of another voting
                  </div>
                  <button class="btn btn-primary" (click)='allowVoting(); termsEditable = true; disapledType= false;' *ngIf="meeting.meetingType != 0">{{ 'meetings.AddVotingQuestion' | translate }}</button>

              </div>
          </div>
      </div>

      <div *ngIf="(allowVote || item.votingModel) && !startVotingTimer">
          <div class="voting-header">
              <h3> {{ 'meetings.Question' | translate }}</h3>
              <div class="sorting-form" [hidden]='!termsEditable'>
                  <div class="sort-item">
                      <form>
                          <label class="sort-label">   {{ 'meetings.QuestionType' | translate }}: </label>
                          <mat-form-field appearance="standard" class="custom-width">
                              <mat-select
                                  [(ngModel)]='selectedQuestion'
                                  (change)="setSelectedQuestionType($event)"
                                  (selectionChange)="setSelectedQuestionType($event)"
                                  [ngModelOptions]="{standalone: true}">
                                  <mat-option *ngFor="let QuestionType of VotingSchemaType" [value]="QuestionType">
                                      {{QuestionType.name}}
                                  </mat-option>
                              </mat-select>
                          </mat-form-field>

                      </form>
                  </div>
                  <p class="has-error" *ngIf="noSelectedType"> {{ 'meetings.PleasechoiceQuestiontype' | translate }}</p>
              </div>
              <button class="btn btn-gray" (click)="termsEditable = !termsEditable; showDiscards = true; disapledType= true; noSeleted=false;" [hidden]='termsEditable' *ngIf="item.canEdit">
                  <svg width="16" height="16.004" viewBox="0 0 16 16.004">
                      <path id="edit-icon"
                          d="M5.82,14l-3.63-3.63,8.78-8.78,3.63,3.63ZM1.851,11.011l3.33,3.33L.188,16Zm13.865-6.9-.63.63L11.451,1.1l.63-.63a1.624,1.624,0,0,1,2.3,0l1.338,1.338a1.633,1.633,0,0,1,0,2.3Zm0,0"
                          transform="translate(-0.188 0.001)" fill="#888" />
                  </svg>{{ 'users.Edit' | translate }}
              </button>
          </div>
          <div>
              <div class="form-element mb-4">
                  <div class="items-list-container" [ngClass]="{'active': termsEditable}">
                      <div class="terms-control"  [ngClass]="{'disapledInput': noSeleted}"  [hidden]='!termsEditable'>
                          <div>
                              <input [placeholder]="'meetings.QuestionHeader' | translate" class="form-control" [(ngModel)]="listItem"
                                      [ngModelOptions]="{standalone: true}" maxlength="250" (keyup)="setQuestion($event)" [disabled]="noSeleted">
                          </div>
                      </div>
                      <div class="question-viewing"  [hidden]='termsEditable'>
                          <div>
                              {{listItem}}
                          </div>
                      </div>
                      <p class="has-error" *ngIf="emtpyQuestion && listItem == ''">{{ 'meetings.pleaseinsertQuestion' | translate }}  </p>
                      <div class="items-list" *ngIf="selectedQuestionType == 1 || selectedQuestionType == 2">
                          <div class="question-container">
                              <div class="option-list" [ngClass]="{'viewingOption': !termsEditable}">
                                  <div  class="option-control" *ngFor="let item of optionListing; index as optionListingIndex;">
                                      <div class="terms-control" [hidden]='!termsEditable' [ngClass]="{'disapledInput': !listItem}" >
                                          <div>
                                              <input [placeholder]="'meetings.AddOption' | translate" class="form-control"
                                                  [(ngModel)]="optionListing[optionListingIndex]"
                                                  (change)="updateOptionItem($event, optionListingIndex)"
                                                  [ngModelOptions]="{standalone: true}"
                                                  maxlength="250" [disabled]="!listItem || selectedQuestionType == 2" >

                                          </div>
                                          <span class="remove-terms" (click)="removeOptionItem(optionListingIndex)" *ngIf="listItem &&  selectedQuestionType == 1">
                                              <svg  width="12" height="12" viewBox="0 0 12 12">
                                                  <path id="remove-btn" d="M6.18-12.112,4.972-13.32.18-8.528-4.612-13.32-5.82-12.112-1.028-7.32-5.82-2.528-4.612-1.32.18-6.112,4.972-1.32,6.18-2.528,1.388-7.32Z" transform="translate(5.82 13.32)" fill="#bbb"/>
                                              </svg>
                                          </span>
                                      </div>
                                      <div  class="terms-control viewingInput" [hidden]='termsEditable'>{{item}}</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="question-container" [hidden]='!termsEditable' *ngIf="selectedQuestionType ==1">
                          <div class="option-list">
                              <div  class="option-control" >
                                  <div class="terms-control" [ngClass]="{'disapledInput': !listItem}" >
                                      <div>
                                          <input [placeholder]="'meetings.AddOption' | translate" class="form-control" [(ngModel)]="optionItem"
                                              (keydown.enter)="addOptionItem($event)" [ngModelOptions]="{standalone: true}"
                                              maxlength="250" [disabled]='!listItem'>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <p class="has-error" *ngIf="noValidoption">{{ 'meetings.Pleaseinsertatleasttwooption' | translate }} </p>

                  </div>
              </div>
              <div class="modal-btns" *ngIf="showDiscards">
                  <button class="btn btn-cancel" (click)="discardTerms()">{{ 'group.DiscardChanges' | translate }}</button>
                  <button class="btn customBtn" (click)="saveVoting()">{{ 'general.update' | translate }}</button>
              </div>
              <div class="modal-btns" [hidden]='!termsEditable' *ngIf="!showDiscards">
                  <button type="button" class="close closebtn" (click)='resetForm(); allowVote = false'>
                      <span> {{ 'meetings.cancel' | translate }}</span>
                  </button>
                  <button type="submit" class="btn customBtn" [disabled]="loading" (click)="saveVoting()" [ngClass]="{ 'loading': loading}">{{ 'meetings.CreateQuestion' | translate }}</button>
              </div>

          </div>
      </div>

      <!-- ((liveview && meeting.meetingType == 0) or meeting secadule) && item.votingModel  -->
      <!-- startVotingTimer ask nareman azay timer w hwa lesa m4 live -->
      <div class="btn-start" *ngIf='meeting.meetingType == 0 && liveView && !startVotingTimer && item.votingModel'>
          <button class="btn btn-primary" (click)='start()'>
              <svg width="13" height="17" viewBox="0 0 13 17">
              <path id="play-icon" d="M73.562,6.921,63.947.457A2.374,2.374,0,0,0,62.684,0c-.719,0-1.164.567-1.164,1.515V15.487c0,.947.444,1.513,1.161,1.513a2.354,2.354,0,0,0,1.258-.458l9.62-6.464A1.932,1.932,0,0,0,74.52,8.5,1.926,1.926,0,0,0,73.562,6.921Z" transform="translate(-61.52)" fill="#fff"/>
              </svg>
               {{ 'meetings.Start' | translate }}
          </button>
      </div>
  </ng-container>

  <app-voting-tabs *ngIf='startVotingTimer || item.allowedVoting || item.votingClosed'
                    [stopedClicked]="stopedClicked"
                    [availableTime] = 'durationTime'
                    [item]='item'
                    (canEndVote)='canEndVote = $event'
                    (openTaskForm)='openCreateTask($event)'></app-voting-tabs>

  <div class="stop-footer" *ngIf="(canEndVote || (durationTime <= 0 && startVotingTimer)) && !item.votingClosed">
      <span *ngIf="canEndVote">
         {{ 'meetings.Allattendeesanswered' | translate }}
      </span>
      <button class="btn btn-primary" (click)='stop(); stopedClicked = true;'>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <rect id="stop-icon" width="12" height="12" rx="2" fill="#fff"/>
            </svg>
           {{ 'meetings.Stop' | translate }}
      </button>
  </div>
</div>
